import axios from 'axios'
import React, { useEffect, useState } from 'react'
import { Link } from 'react-router-dom';

function Dashboard() {

  const [auth,setAuth] = useState(false);
  const [name,setName] = useState("");
  const [message,setMessage] = useState("");

  axios.defaults.withCredentials=true

  useEffect(()=>{
    axios.get("http://localhost:8081")
    .then(res=>{
        if(res.data.Status==="Success"){
          setAuth(true);
          setName(res.data.name);
        }else{
           setAuth(false);
          setMessage(res.data.Message);
        }
    }).catch(err=>{
      console.log(err);
    })
  },[])

  const handleLogout=()=>{
    axios.get("http://localhost:8081/logout")
    .then(res=>{
      if(res.data.Status==="Success"){
      window.location.reload(true);
      }else{
        alert("Error")
      }
    }).catch(err=> console.log(err))
  }

  return (
    <>
      
      <div className="bg-primary vh-100 d-flex justify-content-center align-items-center text-center">
      <div className="container">

      {
        auth ?
        <div>
              <h3>You are Authorized {name}</h3>
              <button className='btn btn-warning' onClick={handleLogout}>Logout</button>
        </div>
        :
        <div>
          {/* <h3>{message}</h3> */}
          <h1 className='text-white'>This Is Admin Job Posting Dashboard</h1>
          <Link to="/admin-login" onClick={handleLogout} className="btn btn-warning text-white fw-bold">Logout</Link>
          </div>

      }


        
      </div>
      </div>


    </>
  )
}

export default Dashboard
